var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmptynft(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 73,
    viewBox: "0 0 72 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_559_34453)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8.5,
    width: 56,
    height: 56,
    rx: 28,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.8627 32.5183V23.1611C48.8627 22.2407 48.1157 21.4938 47.1953 21.4938H44.099C43.1786 21.4938 42.4316 22.2407 42.4316 23.1611V27.006",
    stroke: "url(#paint0_linear_559_34453)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9941 34.3558L33.8295 23.3545C35.0783 22.2841 36.9208 22.2841 38.1696 23.3545L51.0066 34.3558",
    stroke: "url(#paint1_linear_559_34453)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1387 32.5183V48.1715C23.1387 50.014 24.631 51.5063 26.4734 51.5063H34.3333",
    stroke: "url(#paint2_linear_559_34453)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.173 53.1736C41.0297 53.1736 37.6699 49.8139 37.6699 45.6705C37.6699 41.5271 41.0297 38.1674 45.173 38.1674C49.3181 38.1674 52.6762 41.5271 52.6762 45.6705C52.6762 49.8139 49.3181 53.1736 45.173 53.1736",
    stroke: "url(#paint3_linear_559_34453)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.1381 44.1882L44.4332 47.8931L42.209 45.6705",
    stroke: "url(#paint4_linear_559_34453)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_559_34453",
    x: -9.53674e-7,
    y: 0.499999,
    width: 72,
    height: 72,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -2,
    dy: -2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.992157 0 0 0 0 1 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_559_34453"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.733333 0 0 0 0 0.764706 0 0 0 0 0.807843 0 0 0 0.6 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_559_34453",
    result: "effect2_dropShadow_559_34453"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_559_34453",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_559_34453",
    x1: 45.6471,
    y1: 21.4938,
    x2: 45.6471,
    y2: 32.5183,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6B349A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C37C3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_559_34453",
    x1: 36.0004,
    y1: 22.5517,
    x2: 36.0004,
    y2: 34.3558,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6B349A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C37C3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_559_34453",
    x1: 28.736,
    y1: 32.5183,
    x2: 28.736,
    y2: 51.5063,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6B349A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C37C3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_559_34453",
    x1: 45.173,
    y1: 38.1674,
    x2: 45.173,
    y2: 53.1736,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6B349A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C37C3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_559_34453",
    x1: 45.1736,
    y1: 44.1882,
    x2: 45.1736,
    y2: 47.8931,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6B349A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C37C3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptynft);
export default __webpack_public_path__ + "static/media/emptynft.e28226896ac558b5f1d4d783fa685960.svg";
export { ForwardRef as ReactComponent };